// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N8GbM","content":"styles_content__1pNCe"};